import { primaryColor, hexToRgb, whiteColor, blackColors } from 'assets/jss/material-dashboard-pro-react';

export default {
	content: {
		maxWidth: 960,
		margin: '0 auto',
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		padding: '12px 0',
		position: 'fixed',
		bottom: 0,
		zIndex: 6000,
		'&::before': {
			position: 'absolute',
			content: '" "',
			backgroundColor: whiteColor,
			top: 0,
			left: 0,
			height: '100%',
			width: '100%',
			zIndex: -1,
		},
		'&::after': {
			position: 'absolute',
			content: '" "',
			top: 0,
			left: 0,
			zIndex: -1,
			height: '100%',
			width: '100%',
			backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.2)`,
		},
		width: '100vw',
		display: 'flex',
	},
	icon: {
		margin: '0 26px',
	},
	text: {
		marginRight: 56,
	},
	close: {
		position: 'absolute',
		right: 16,
		top: '50%',
		height: 24,
		transform: 'translateY(-50%)',
		cursor: 'pointer',
		'& svg': {
			color: blackColors[3],
		},
		'&:hover svg': {
			color: blackColors[2],
		},
	},
};
